
define('tpl!taoOutcomeUi/component/results/list', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<div class=\"component results-list\">\n    <div class=\"list\"></div>\n</div>";
  });
});

